import { displayPolygon } from "./displayPolygon";
import { hidePolygon } from "./hidePolygon";

export const displayHideAreaPolygon = (
    btn,
    areaPath,
    PathCoord,
    zoneDisplayed,
    setZoneDisplayed,
    color,
    index,
    mapData,
    mapsData,
    addListenersOnEditSiteAreaChangesPolygon,
    addListenersOnEditSiteAreaFinalPolygon,
    addListenersOnEditAreaFinalPolygon,
    polygonClick,
    polyMouseOver,
    polyMouseOut,
    showAreas
  ) => {

    if (
      areaPath !== undefined &&
      showAreas &&
      btn &&
      zoneDisplayed.length === 0
    ) {
      displayPolygon(
        areaPath,
        PathCoord,
        setZoneDisplayed,
        color,
        index,
        mapData,
        mapsData,
        addListenersOnEditSiteAreaChangesPolygon,
        addListenersOnEditSiteAreaFinalPolygon,
        addListenersOnEditAreaFinalPolygon,
        polygonClick,
        polyMouseOver,
        polyMouseOut,
      );
    } else if (areaPath !== undefined) {
      hidePolygon(zoneDisplayed, setZoneDisplayed);
    }
  };